import React, { Component } from 'react'
import { connect } from 'react-redux'
import setActiveCabin from '../../actions/setActiveCabin'
import removeActiveCabin from '../../actions/removeActiveCabin'
import { clearCategoryCode } from '../../actions/setActiveSearchFilters'

import Checkbox from '../../components/elements/Checkbox'

import '../../styles/scss/components/equote-cabin-table-selection.scss'

class EQuoteCabinsTableButton extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isCabinSelected: props.isSelected
    }
  }

  componentDidMount() {
    this.checkForPreSelectedCabin()
  }

  componentDidUpdate() {
    this.checkForPreSelectedCabin()
  }

  checkForPreSelectedCabin() {
    const {
      activeSearchFilterData,
      cabinData,
      isSelected,
      hasNonRefundableSibling,
      hasRefundableSibling
    } = this.props
    const {
      isRefundable,
      isSuperCategory,
      stateroomCategoryCode
    } = cabinData

    const isCategoryMatch =
      !isSuperCategory &&
      activeSearchFilterData.categoryCode &&
      activeSearchFilterData.categoryCode === stateroomCategoryCode

    // RateType=RD requests the Regular (refundable) deposit; absent/NRD keeps
    // the default Non-Refundable preference. In both cases prefer the requested
    // variant when it exists for this category, but fall back to the other
    // variant when it doesn't (e.g. group sailings that only offer one).
    const prefersRefundable =
      (activeSearchFilterData.rateType || '').toUpperCase() === 'RD'

    const matchesPreferredRate = prefersRefundable
      ? isRefundable === true ||
        (isRefundable === false && !hasRefundableSibling)
      : isRefundable === false ||
        (isRefundable === true && !hasNonRefundableSibling)

    const isPreSelectedCabin = isCategoryMatch && matchesPreferredRate

    if (!isSelected && !this.preSelectionInFlight && isPreSelectedCabin) {
      this.preSelectionInFlight = true
      this.props.handleSetActiveCabin()
      this.props.clearCategoryCode()
    }
  }

  onRemoveActiveCabin = () => {
    this.props.handleRemoveActiveCabin()
  }

  onSetActiveCabin = () => {
    this.props.handleSetActiveCabin()
  }

  handleCheckboxClick = () => {
    const { numberOfActiveCabinsBySailing } = this.props
    const disableCheckBox = numberOfActiveCabinsBySailing >= 8

    this.state.isCabinSelected
      ? this.onRemoveActiveCabin()
      : !disableCheckBox && this.onSetActiveCabin()
  }

  render() {
    const { label, packageData, cabinData } = this.props
    const key = `${packageData.identifier}-${cabinData.pricingDisplayName}-${
      cabinData.stateroomCategoryCode
    }`
    return (
      <div className="equote-cabin-table-cabin-selection">
        <label>
          <Checkbox
            checked={this.state.isCabinSelected}
            key={key}
            onClick={this.handleCheckboxClick}
            id={key}
          />
          <span>{label}</span>
        </label>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const {
    isRefundable,
    stateroomCategoryCode,
    superCategoryCode
  } = ownProps.cabinData

  const {
    landPackageIdentifier,
    isLandPackage,
    identifier,
    stateKey
  } = ownProps.packageData

  const packageIdentifier = isLandPackage
    ? landPackageIdentifier
    : identifier
  const pricingIdentifier = `${
    isRefundable ? 'refundable' : 'nonRefundable'
  }-${stateroomCategoryCode}`

  // For group sailings (and any package whose pricing only has refundable
  // entries for a category), the non-refundable button never renders, so the
  // deep-link auto-select fails. Detect whether the category has a
  // non-refundable counterpart in this package's pricing so the refundable
  // button can stand in as the pre-selected target.
  const availableStateRooms =
    state?.[stateKey]?.allPackages?.[packageIdentifier]?.pricing?.[
      superCategoryCode
    ]?.availableStateRooms || []
  const hasNonRefundableSibling = availableStateRooms.some(
    room =>
      room.stateroomCategoryCode === stateroomCategoryCode &&
      room.isRefundable === false
  )
  // Mirror of the above for the RateType=RD path: when the deep link requests
  // the Regular (refundable) deposit but the category only has a non-refundable
  // entry, the refundable button never renders, so let non-refundable stand in.
  const hasRefundableSibling = availableStateRooms.some(
    room =>
      room.stateroomCategoryCode === stateroomCategoryCode &&
      room.isRefundable === true
  )

  let isSelected = Boolean(
    state.activeCabinData &&
      state.activeCabinData[packageIdentifier] &&
      state.activeCabinData[packageIdentifier][pricingIdentifier]
  )

  let numberOfActiveCabinsBySailing = 0

  // need to only count non-super-category cabins
  // and super-category cabins NOT associated with this cabin
  // that way we can still select a cabin when it's super category was auto selected
  if (state.activeCabinData && state.activeCabinData[packageIdentifier]) {
    numberOfActiveCabinsBySailing = Object.values(
      state.activeCabinData[packageIdentifier]
    ).reduce((total, selectedCabin) => {
      if (
        selectedCabin.isSuperCategory &&
        selectedCabin.superCategoryCode === superCategoryCode
      ) {
        return total
      }
      total += 1
      return total
    }, 0)
  }
  return {
    isSelected,
    numberOfActiveCabinsBySailing,
    activeSearchFilterData: state.activeSearchFilterData,
    hasNonRefundableSibling,
    hasRefundableSibling
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const {
    superCategoryCode,
    isRefundable,
    isSuperCategory,
    stateroomCategoryCode
  } = ownProps.cabinData

  const {
    stateKey,
    id,
    sailDate,
    isLandPackage,
    landPackageIdentifier,
    identifier,
  } = ownProps.packageData

  const packageIdentifier = isLandPackage
    ? landPackageIdentifier
    : identifier
  const pricingIdentifier = `${
    isRefundable ? 'refundable' : 'nonRefundable'
  }-${stateroomCategoryCode}`
  const activeCabinData = {
    superCategoryCode,
    isRefundable,
    isSuperCategory,
    stateKey,
    id,
    sailDate,
    stateroomType: stateroomCategoryCode,
    packageIdentifier
  }

  return {
    handleSetActiveCabin() {
      return dispatch(
        setActiveCabin(packageIdentifier, pricingIdentifier, activeCabinData)
      )
    },
    handleRemoveActiveCabin() {
      return dispatch(removeActiveCabin(packageIdentifier, pricingIdentifier))
    },
    clearCategoryCode() {
      return dispatch(clearCategoryCode())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EQuoteCabinsTableButton)
